<template>
    <v-container>
        <v-row>
            <v-col>
                <span class="headline">LEGGE TIL BRUKER I SELSKAP:</span>
                <brreg @organisation="organisationPicked"></brreg>
                <v-btn @click="addUserToCompany(organisation)" :disabled="!organisation" color="success" class="float-right"><v-icon left>mdi-plus</v-icon>Legg til</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as axios from "axios";

export default {
    data: () => ({
        organisation: null
    }),
    methods: {
        organisationPicked(organisation){
            this.organisation = organisation;
        },
        addUserToCompany(company) {
            // debugger;
            // console.log(company);

            axios
                .post("/company/relateuser", { company })
                .then(response => {
                    if (response.status === 200) {
                        // debugger;
                        // new company is not approved yet, so no need to fetch it
                        this.$router.push("home");
                    }
                })
                // .catch(err => {
                //     console.log(err);
                //     // TODO snackbar
                // });
        }
    }
};
</script>

<style lang="scss" scoped>
</style>